/** Página pública de "Profesionales con Propósito" — directorio curado, ver contexto completo
 *  en src/lib/partner-professionals.ts. A propósito NO está enlazada desde SiteNav/Footer ni
 *  en public/sitemap.xml, y lleva "noindex" — se revela recién cuando haya profesionales reales
 *  cargados desde CP Admin. Mientras tanto solo es alcanzable por quien tenga el link directo.
 *  El contenido real vive en profesionales-con-proposito-page.tsx y se descarga aparte
 *  (code-split) — así visitar el home u otra página pública no baja este bundle. */

import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profesionales-con-proposito",
  head: () => ({
    meta: [
      ...seoMeta({
        title: "Profesionales con Propósito — Calistenia Progresiva",
        description: "Un directorio curado de profesionales de la salud y del deporte que comparten la filosofía de progresión sostenible de Calistenia Progresiva.",
        path: "/profesionales-con-proposito",
      }),
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [canonicalLink("/profesionales-con-proposito")],
  }),
  component: lazyRouteComponent(() => import("./profesionales-con-proposito-page"), "ProfesionalesPropositoPage"),
});
